import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class MySqlCollections extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    mysqlCollections: null,
  };
  async componentDidMount() {
    const { match, actions } = this.props;
    const { dbUuid, projectId, version } = match.params;
    await actions.getMySqlExternalDb({ projectId, dbUuid, version });
    await actions.collectionListExternaldbs({ projectId, dbUuid, version });
  }
  getOrdinalSuffix = (day) => {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    const lastDigit = day % 10;
    switch (lastDigit) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };
  formatDate = (date) => {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
    const day = date.getDate();
    const ordinalSuffix = this.getOrdinalSuffix(day);
    return formattedDate.replace(/\b\d+\b/, (match) => match + ordinalSuffix);
  };
  handleContinueButtonClick = () => {
    const { match, actions, history } = this.props;
    const { dbUuid, projectId, version } = match.params;
    history.push(`/2.0/data-connector/${version}/v/${projectId}/mysql-datasource/${dbUuid}/create`);
  };

  renderDataConnectorTableList = () => {
    const { dataConnector } = this.props;
    const { mysqlStoredData, getMySqlExternalDbPending } = dataConnector || '';
    const { completeData } = mysqlStoredData || {};
    const { tables } = completeData || {};
    if (getMySqlExternalDbPending || !tables) {
      return (
        <div className="text-center">
          <CustomLoader loading={getMySqlExternalDbPending} size="20px" color="#303453" />
        </div>
      );
    } else {
      return (
        <ParentContentCard
          title={` List of Collections via MySQL (${tables.length})`}
          icon={'collection'}
        >
          <div className="table-responsive">
            <table className="table table-bordered table-hover table-sm table-word-break connector-list">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>No. of Fields</th>
                  <th>Created at</th>
                  <th>Updated at</th>
                </tr>
              </thead>
              {this.renderCollectionTableBody(tables)}
            </table>
          </div>

          {tables && tables.length > 0 && (
            <div className="card-footer flex-end">
              <button
                className="btn btn-theme-submit mt-3 float-right"
                onClick={this.handleContinueButtonClick}
              >
                <i className="wb webconnect-rocket"></i>
                &nbsp;Continue&nbsp;
              </button>
            </div>
          )}
        </ParentContentCard>
      );
    }
  };

  renderCollectionTableBody(tables) {
    return (
      <tbody>
        {tables &&
          tables.map((item, index) => {
            return this.renderCollectionTableBodyRow(item, index);
          })}
      </tbody>
    );
  }

  renderCollectionTableBodyRow(item, index) {
    return (
      <tr className="text-left td-align-middle" key={item.name + index}>
        <td>{item.name}</td>
        <td>{Object.keys(item.fields).length}</td>
        <td>Not yet created</td>
        <td>Not yet updated</td>
      </tr>
    );
  }

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }
    const { getMySqlExternalDbPending, collectionListExternaldbsPending } =
      this.props.dataConnector;
    if (getMySqlExternalDbPending || collectionListExternaldbsPending) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader
              loading={getMySqlExternalDbPending || collectionListExternaldbsPending}
              size="20px"
              color="#303453"
            />
          </div>
        </CommonPageComponent>
      );
    }
    return <CommonPageComponent>{this.renderDataConnectorTableList()}</CommonPageComponent>;
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MySqlCollections);
